import { QueryClient } from '@tanstack/react-query';
import { HavePaginationEntity } from 'src/entities/HavePagination.entity';

interface HasId {
  id: number | string;
}

function updateQueryCache<T extends HasId>(queryClient: QueryClient, cacheKey: string, newItem: T) {
  const querires = queryClient.getQueryCache().findAll({ predicate: (query) => query.queryKey.includes(cacheKey) });
  querires.forEach((query) => {
    queryClient.setQueryData(query.queryKey, (oldData: HavePaginationEntity<T>) => {
      if (oldData && oldData.data) {
        return {
          ...oldData,
          data: oldData.data.map((it) => (it.id === newItem.id ? newItem : it)),
        };
      }
      return oldData;
    });
  });
}

export default updateQueryCache;
